import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from './App.jsx'
import { registerIllustrationSW } from '@utils/illustrationCache'

// Register illustration cache SW early — it only intercepts /api/illustration/* requests
registerIllustrationSW()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
)
